/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save(props) {
	const{attributes} = props;
	return (
		<div { ...useBlockProps.save({className: `${attributes.circleTextRotate ? 'is-rotating' : ''}`}) }>
			<div 
				className="wpopus-circle-text-path-wrapper"
				style={{
					"--wpopus-circle-text-size": `${attributes.circleTextSize}px`,
				}}
			>
				<svg viewBox="0 0 200 200">
					<defs>
						<path
							id="circle"
							d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
						/>
					</defs>
					<text textAnchor="middle">
						<textPath href="#circle" startOffset="50%">
							{attributes.circleText}
						</textPath>
					</text>
				</svg>
			</div>
		</div>
	);
}
